import Input, { InputProps } from "./Input";

export { Input, InputProps };

export default Input;
